"use strict";
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
Object.defineProperty(exports, "__esModule", { value: true });
function createCursorMovedEvent(currentCursor, action) {
    var updatedCursor = action.cursor;
    if (currentCursor && currentCursor.i === updatedCursor.i && currentCursor.j === updatedCursor.j) {
        return null;
    }
    return {
        cursor: updatedCursor ? {
            i: updatedCursor.i,
            j: updatedCursor.j,
            td: action.grid[updatedCursor.i][updatedCursor.j]
        } : null
    };
}
exports.createCursorMovedEvent = createCursorMovedEvent;
function createSelectionChangeEvent(currentSelection, action) {
    var e_1, _a;
    var deselected = currentSelection.reduce(function (existingDict, cell) {
        existingDict[cellIndexKey(cell)] = cell;
        return existingDict;
    }, {});
    var grid = action.grid, updatedSelection = action.updatedSelection;
    var selected = {};
    var selection = [];
    var _loop_1 = function (cell) {
        var key = cellIndexKey(cell);
        var td = grid[cell.i][cell.j];
        var addToSelection = !selection.some(function (p) { return p.td === td; });
        if (addToSelection) {
            if (!deselected[key]) {
                selected[key] = {
                    i: cell.i,
                    j: cell.j,
                    td: grid[cell.i][cell.j]
                };
            }
            selection.push({ i: cell.i, j: cell.j, td: td });
            deselected[key] = undefined;
        }
    };
    try {
        for (var _b = __values(updatedSelection.enumerateCells()), _c = _b.next(); !_c.done; _c = _b.next()) {
            var cell = _c.value;
            _loop_1(cell);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    var event = {
        selected: Object.values(selected),
        deselected: Object.values(deselected).filter(function (p) { return !!p; }),
        selection: selection
    };
    if (!event.selected.length && !event.deselected.length) {
        return null;
    }
    return event;
}
exports.createSelectionChangeEvent = createSelectionChangeEvent;
function cellIndexKey(cell) {
    return cell.i + "," + cell.j;
}
